import { render, staticRenderFns } from "./PurposeType.vue?vue&type=template&id=76436c4a"
import script from "./PurposeType.vue?vue&type=script&lang=js"
export * from "./PurposeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports